import { sportMap } from '../data/sports';
import type { Group } from '../types';
import { Icon } from './Icon';

export function GroupCard({ group, onJoin, onChat }: { group: Group; onJoin: (group: Group) => void; onChat: (group: Group) => void }) {
  const remaining = group.maxMembers - group.memberCount;
  return <article className="group-card">
    <div className="group-card-top">
      <div className="sport-tags">{group.sports.map((id) => {
        const sport = sportMap.get(id);
        return <span className="sport-tag" key={id}>{sport?.emoji ?? '🎽'} {sport?.name ?? id}</span>;
      })}</div>
      <button className="heart-button" aria-label="찜하기"><Icon name="heart" size={20}/></button>
    </div>
    <h3>{group.title}</h3>
    <p className="group-description">{group.description}</p>
    <div className="group-meta">
      <span><Icon name="clock" size={17}/><b>{group.dateLabel}</b></span>
      <span><Icon name="map" size={17}/>{group.area} · {group.place}</span>
      <span><Icon name="users" size={17}/>{group.level} · {group.ageRule}</span>
    </div>
    <div className="group-card-bottom">
      <div className="host"><span className="host-avatar" style={{ backgroundColor: group.hostColor }}>{group.hostInitial}</span><span>{group.hostName}님</span></div>
      <div className="join-area">
        <span className={`remaining ${remaining <= 1 ? 'urgent' : ''}`}>{remaining > 0 ? `${remaining}자리 남음` : '마감'}</span>
        <div className="card-actions"><button className="chat-button" onClick={() => onChat(group)}>💬 채팅</button><button className={`join-button ${group.joined ? 'joined' : ''}`} disabled={remaining <= 0 || group.joined} onClick={() => onJoin(group)}>{group.joined ? '참여 완료' : group.fee ? `${group.fee.toLocaleString()}원 · 참여` : '무료 · 참여'}</button></div>
      </div>
    </div>
  </article>;
}
